import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import {FaFacebookF, FaTwitter, FaInstagram,FaEnvelope,FaClock,FaPhoneAlt,FaMapMarkerAlt} from 'react-icons/fa';

const Career = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  const staff = [
    { name: "John Doe", role: "CEO & Founder", img: "/staff1.jpg" },
    { name: "Jane Smith", role: "Volunteer", img: "/staff1.jpg" },
    { name: "Mike Tyson", role: "Manager", img: "/staff1.jpg" },
    { name: "Sara Wilson", role: "Director", img: "/staff1.jpg" },
  ];

    const eventList = [
    { id: 1, day: '25', month: 'FEBRUARY 16', title: 'HOMELESS EVENT' },
    { id: 2, day: '26', month: 'FEBRUARY 16', title: 'POOR SL EVENT' },
    { id: 3, day: '27', month: 'FEBRUARY 16', title: 'POOR SL EVENT' },
    { id: 4, day: '28', month: 'FEBRUARY 16', title: 'CYCLON VICTIM' },
    { id: 5, day: '29', month: 'FEBRUARY 16', title: 'VILLAGE FUND' },
    { id: 6, day: '30', month: 'FEBRUARY 16', title: 'CHILDREN FUND' },
  ];

    const [successMsg, setSuccessMsg] = useState('');
      const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
        const [errors, setErrors] = useState({});
        const [isSubmitting, setIsSubmitting] = useState(false);
      
        const validate = () => {
          let tempErrors = {};
          if (!formData.name.trim()) tempErrors.name = "Name is required";
          if (!formData.email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)) tempErrors.email = "Invalid email format";
          if (!formData.subject) tempErrors.subject = "Subject is required";
          if (formData.message.length < 10) tempErrors.message = "Message must be at least 10 characters";
          setErrors(tempErrors);
          return Object.keys(tempErrors).length === 0;
        };
      
        const handleSubmit = (e) => {
          e.preventDefault();
          if (validate()) {
            setIsSubmitting(true);
            setTimeout(() => {
              setIsSubmitting(false);
              setSuccessMsg("Thank you! Your message has been sent successfully.");
              setFormData({ name: '', email: '', subject: '', message: '' });
              setTimeout(() => setSuccessMsg(''), 5000);
            }, 2000);
          }
        };
      
        const handleChange = (e) => {
          setFormData({ ...formData, [e.target.name]: e.target.value });
          if (errors[e.target.name]) setErrors({ ...errors, [e.target.name]: '' });
        };
  
  return (
    <div className="min-h-screen bg-white font-sans overflow-x-hidden">
        
            {/* 1. HERO SECTION */}
            <section 
                className="relative h-[45vh] flex items-center justify-center bg-cover bg-center"
                style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('/gallery.jpg')` }}
            >
                <div className="text-center text-white">
                <motion.h1 
                    initial={{ y: 20, opacity: 0 }} 
                    animate={{ y: 0, opacity: 1 }} 
                    className="text-5xl md:text-6xl font-serif font-black uppercase tracking-tight"
                >
                    Our Career 
                </motion.h1>
                <div className="h-1.5 w-20 bg-[#f9b50b] mx-auto mt-4"></div>
                
                <p className="mt-4 uppercase tracking-[0.3em] text-xs font-bold">
                    <Link to="/" className="hover:text-[#f9b50b] text-gray-300 transition-colors">Home</Link>
                    <span className="mx-2 text-gray-400">/</span>
                    <span className="text-white">Career</span>
                </p>
                </div>
            </section>

                {/* 2. SECTION */}
                <section className="px-4 bg-white -mt-10 relative z-10">
                        <div className="max-w-6xl mx-auto shadow-2xl overflow-hidden border border-gray-100">
                          <div className="bg-[#f9b50b] p-12 flex flex-col md:flex-row items-center justify-between gap-8">
                            <h2 className="text-3xl font-serif font-bold uppercase leading-tight text-[#221f1f]">
                              I want to spend my life <br/> helping people,
                            </h2>
                            <button 
                              onClick={scrollToTop} 
                              className="border-2 border-[#221f1f] px-14 py-4 font-black uppercase text-xs hover:bg-[#221f1f] hover:text-white transition-all"
                            >
                              Join Us
                            </button>
                          </div>
                        </div>
                      </section>

                    {/* 3. STAFF*/}
                        <section className="py-24 bg-white border-t border-gray-100">
                            <div className="max-w-7xl mx-auto px-6">
                            <div className="text-center mb-16">
                                <h2 className="text-4xl font-serif font-bold uppercase mb-4">Meet Our Staff</h2>
                                <div className="h-1 w-20 bg-[#f9b50b] mx-auto"></div>
                            </div>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                                {staff.map((member, i) => (
                                <div key={i} className="group relative overflow-hidden bg-gray-900 aspect-[3/4]">
                                    <img src={member.img} className="w-full h-full object-cover transition-all duration-700 group-hover:opacity-40" alt={member.name}/>
                                    <div className="absolute inset-0 flex flex-col items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-500">
                                    <h4 className="text-white font-serif font-bold text-xl uppercase">{member.name}</h4>
                                    <p className="text-[#f9b50b] text-xs font-bold uppercase tracking-widest mb-6">{member.role}</p>
                                    <div className="flex gap-4 text-white"><FaFacebookF/><FaTwitter/><FaInstagram/></div>
                                    </div>
                                </div>
                                ))}
                            </div>
                            </div>
                        </section>

                    {/* 4. WAYS TO SERVE HUMANITY SECTION. */}
                  <section className="relative py-32 my-20 flex flex-col items-center justify-center text-center text-white bg-fixed bg-cover bg-center" style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url('/homeimage1.jpg')` }}>
                    <div className="max-w-4xl px-6">
                      <h2 className="text-5xl font-serif font-bold uppercase mb-6">WAYS TO SERVE <span className="text-[#f9b50b]">HUMANITY</span></h2>
                      <p className="text-base leading-relaxed mb-6 opacity-90 italic">“No single person can change the entire world. But together, we can make a difference in the lives of many — starting today.”</p>
                      <h3 className="text-[#f9b50b] font-bold uppercase mb-12">— BE THE CHANGE</h3>
                      <Link to="/donate" className="bg-[#f9b50b] text-[#221f1f] px-14 py-4 font-black uppercase text-xs tracking-widest hover:bg-white hover:text-[#221f1f] transition-all">Join Us</Link>
                    </div>
                  </section>

                    {/* 5.*/}
                  <section className="py-24 bg-white px-6 max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16">
                    <div>
                      <h2 className="text-2xl font-serif font-bold uppercase mb-4 border-b-2 border-[#f9b50b] inline-block pb-1">UPCOMMING EVENTS</h2>
                      <p className="text-gray-500 text-sm mb-8 leading-relaxed">Doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur</p>
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                                      {eventList.map((event) => (
                                        <div 
                                          key={event.id} className="bg-white border-2 border-gray-100 p-4 text-center transition-all duration-300 hover:border-[#f9b50b] group cursor-pointer"      >
                                          {/* Date Section */}
                                          <div className="mb-4">
                                            <span className="text-4xl font-serif font-bold text-[#221f1f] block leading-none">
                                              {event.day}
                                            </span>
                                            <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-gray-400 mt-1 block">
                                              {event.month}
                                            </span>
                                          </div>
                      
                                          {/* Title Section */}
                                          <h3 className="text-[15px] font-serif font-bold uppercase mb-5 text-[#221f1f] group-hover:text-[#f9b50b] transition-colors leading-tight min-h-[40px] flex items-center justify-center">
                                            {event.title}
                                          </h3>
                      
                                        
                                          {/* Read More Divider & Link */}
                                            <Link 
                                              to="/EventsDetail" 
                                              className="text-[11px] font-bold uppercase tracking-widest mb-5 text-gray-400 hover:text-[#221f1f] flex items-center justify-center gap-2 group/btn"
                                            >
                                              Read More 
                                              <span className="text-[#f9b50b] font-normal tracking-tighter opacity-70 group-hover/btn:opacity-100">---</span>
                                            </Link>
                                        </div>
                                      ))}
                                    </div>
                    </div>
                    <div>
                        {/* TOP CONTENT */}
                        <h2 className="text-2xl font-serif font-bold uppercase mb-4 border-b-2 border-[#f9b50b] inline-block pb-1 text-[#221f1f]">
                            Become Help
                        </h2>
                        <p className="text-gray-500 text-sm mb-10 italic max-w-3xl">
                            Doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore
                            veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim
                            ipsam voluptatem quia voluptas
                        </p>
                        {/* IMAGE SECTION */}
                        <div className="w-full min-h-[360px] bg-cover bg-center relative"style={{ backgroundImage: "url('/6.jpg')" }}>
                            {/* OVERLAY */}
                            <div className="absolute inset-0 bg-[#221f1f]/70 flex flex-col justify-center px-6 md:px-12">
                                <h2 className="text-white text-3xl md:text-4xl font-extrabold uppercase mb-2">
                                    For You Right Choice
                                </h2>

                                <h3 className="text-[#f9b50b] text-xl md:text-2xl font-bold uppercase mb-4">
                                    Change Their World
                                </h3>

                                <p className="text-gray-200 text-sm md:text-base max-w-2xl mb-6">
                                    Quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam
                                    voluptatem quia voluptas sit aspernatur aut odit
                                </p>
                                </div>
                            </div>
                            {/* BUTTONS */}
                            <div className="flex gap-4 flex-wrap mt-8 mx-auto justify-center">
                                <button onClick={scrollToTop} className="bg-[#f9b50b] text-[#221f1f] font-bold px-6 py-3 uppercase text-sm hover:opacity-90 transition">
                                Become Donator
                                </button>

                                <button onClick={scrollToTop} className="bg-[#f9b50b] text-[#221f1f] font-bold px-6 py-3 uppercase text-sm hover:opacity-90 transition">
                                Become Adopter
                                </button>
                            </div>
                        </div>
                    </section>

                    {/* 6. */}
                    <section className="bg-[#1a1818] py-20 px-6 border-y border-gray-800">
                        <div className="max-w-4xl mx-auto text-center">
                        <h2 className="text-white text-4xl font-serif font-bold uppercase tracking-wider mb-4">
                            Subscribe <span className="text-[#f9b50b]">Now</span>
                        </h2>
                        <p className="text-gray-400 text-sm md:text-base mb-10 font-light max-w-2xl mx-auto leading-relaxed">
                            Receive our weekly newsletter with educational materials, upcoming interfaith events, 
                            and stories of unity from our community.
                        </p>
                        <form className="flex flex-col md:flex-row items-center justify-center gap-0 max-w-2xl mx-auto shadow-2xl">
                            <input
                            type="email"
                            placeholder="Your Email Address"
                            required
                            className="w-full md:w-2/3 py-4 px-6 focus:outline-none bg-white text-[#1a1818] text-sm"
                            />
                            <button
                            type="submit"
                            className="w-full md:w-1/3 py-4 px-6 bg-[#f9b50b] border-2 border-[#f9b50b] text-[#1a1818] font-black uppercase tracking-widest hover:bg-transparent hover:text-[#f9b50b] transition-all duration-300 text-xs"
                            >
                            Subscribe
                            </button>
                        </form>
                        <p className="text-[10px] text-gray-600 uppercase tracking-[0.2em] mt-6">
                            Unity in Diversity • Illinois Interfaith
                        </p>
                        </div>
                    </section>

                    {/* 7. */}
                    {/* 2. GET IN TOUCH HEADER */}
                                <section className="pt-20 pb-10 text-center">
                                  <h2 className="text-5xl font-serif font-bold uppercase text-[#221f1f] mb-2">Get In Touch</h2>
                                  <p className="text-gray-400 text-sm uppercase tracking-widest font-bold">Contact Us</p>
                                  <div className="h-[2px] w-16 bg-[#f9b50b] mx-auto mt-6"></div>
                                </section>
                          
                                {/* 3. MAIN CONTACT CONTENT */}
                                <section className="pb-24 px-6 max-w-7xl mx-auto">
                                  <div className="grid grid-cols-1 lg:grid-cols-3 gap-16">
                                    
                                    {/* LEFT COLUMN: CONTACT INFO */}
                                    <div className="lg:col-span-1 space-y-12">
                                      <div className="flex gap-5">
                                        <FaMapMarkerAlt className="text-[#f9b50b] text-2xl mt-1" />
                                        <div >
                                          <h4 className="font-serif font-bold text-xl uppercase mb-3">Office Address</h4>
                                          <a 
                                            href="https://www.google.com/maps/search/?api=1&query=1645+W+Irving+Park+Rd+Suite+100+Hanover+Park+IL+60133" 
                                            target="_blank" 
                                            rel="noopener noreferrer" 
                                            className="text-gray-500 text-sm not-italic leading-relaxed hover:text-[#f9b50b] transition-colors"
                                          >
                                            1645 W Irving Park Rd, Suite # 100 <br />
                                            Hanover Park, IL, United States, Illinois 60133
                                          </a>
                                        </div>
                                      </div>
                          
                                      <div className="flex gap-5">
                                        <FaPhoneAlt className="text-[#f9b50b] text-2xl mt-1" />
                                        <div>
                                          <h4 className="font-serif font-bold text-xl uppercase mb-3">Phone</h4>
                                          <a href="tel:18477377065" className="text-gray-500 text-sm hover:text-[#f9b50b] transition-colors">+1 (847) 737-7065</a>
                                        </div>
                                      </div>
                          
                                      <div className="flex gap-5">
                                        <FaClock className="text-[#f9b50b] text-2xl mt-1" />
                                        <div>
                                          <h4 className="font-serif font-bold text-xl uppercase mb-3">Working Hours</h4>
                                          <p className="text-gray-500 text-sm leading-relaxed">
                                            Monday – Saturday: Always Open <br />
                                            (Community inquiries welcomed anytime) <br />If your template requires fixed hours, use: <br />Monday – Friday: 9:00 AM – 5:00 PM <br />Saturday & Sunday: By Appointment
                                          </p>
                                        </div>
                                      </div>
                          
                                      <div className="flex gap-5">
                                        <FaEnvelope className="text-[#f9b50b] text-2xl mt-1" />
                                        <div>
                                          <h4 className="font-serif font-bold text-xl uppercase mb-3">Email</h4>
                                          <a href="mailto:info@ilinterfaith.org" className="text-gray-500 text-sm hover:text-[#f9b50b] transition-colors">info@ilinterfaith.org</a>
                                        </div>
                                      </div>
                                    </div>
                          
                                    {/* RIGHT COLUMN: CONTACT FORM */}
                                    <div className="lg:col-span-2">
                                      <h3 className="text-2xl font-serif font-bold uppercase mb-8">Send Us Email</h3>
                                      <form onSubmit={handleSubmit} className="space-y-4">
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                          <div className="space-y-1">
                                            <input 
                                              type="text" name="name" value={formData.name} onChange={handleChange}
                                              placeholder="Enter your full name" 
                                              className={`w-full p-4 bg-gray-50 border ${errors.name ? 'border-red-500' : 'border-gray-100'} focus:outline-none focus:bg-white focus:border-[#f9b50b] transition-all text-sm`}
                                            />
                                            {errors.name && <p className="text-red-500 text-[10px] uppercase font-bold pl-1">{errors.name}</p>}
                                          </div>
                                          <div className="space-y-1">
                                            <input 
                                              type="email" name="email" value={formData.email} onChange={handleChange}
                                              placeholder="Enter your email" 
                                              className={`w-full p-4 bg-gray-50 border ${errors.email ? 'border-red-500' : 'border-gray-100'} focus:outline-none focus:bg-white focus:border-[#f9b50b] transition-all text-sm`}
                                            />
                                            {errors.email && <p className="text-red-500 text-[10px] uppercase font-bold pl-1">{errors.email}</p>}
                                          </div>
                                        </div>
                                        
                                        <div className="space-y-1">
                                          <input 
                                            type="text" name="subject" value={formData.subject} onChange={handleChange}
                                            placeholder="Subject" 
                                            className={`w-full p-4 bg-gray-50 border ${errors.subject ? 'border-red-500' : 'border-gray-100'} focus:outline-none focus:bg-white focus:border-[#f9b50b] transition-all text-sm`}
                                          />
                                          {errors.subject && <p className="text-red-500 text-[10px] uppercase font-bold pl-1">{errors.subject}</p>}
                                        </div>
                          
                                        <div className="space-y-1">
                                          <textarea 
                                            name="message" rows="8" value={formData.message} onChange={handleChange}
                                            placeholder="Write your message" 
                                            className={`w-full p-4 bg-gray-50 border ${errors.message ? 'border-red-500' : 'border-gray-100'} focus:outline-none focus:bg-white focus:border-[#f9b50b] transition-all text-sm`}
                                          ></textarea>
                                          {errors.message && <p className="text-red-500 text-[10px] uppercase font-bold pl-1">{errors.message}</p>}
                                        </div>
                          
                                        <button 
                                          disabled={isSubmitting}
                                          className="bg-[#221f1f] text-white font-bold uppercase tracking-widest px-10 py-4 hover:bg-[#221f1f] transition-all disabled:bg-gray-400 mt-4 text-xs shadow-lg"
                                        >
                                          {isSubmitting ? "Sending..." : "Send Message"}
                                        </button>
                          
                                        {successMsg && (
                                          <motion.div 
                                            initial={{ opacity: 0, y: 10 }} 
                                            animate={{ opacity: 1, y: 0 }} 
                                            className="mt-6 p-4 bg-green-50 border border-green-200"
                                          >
                                            <p className="text-green-700 font-bold text-center text-sm uppercase tracking-tight">
                                              {successMsg}
                                            </p>
                                          </motion.div>
                                        )}
                                      </form>
                                    </div>
                                  </div>
                                </section>


    </div>
  );
};

export default Career;